// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__u0J7n","inputDescription":"styles_inputDescription__1HkIC"};